<template>
  <div>
    <a href="/#/home" class="logo">index</a>
    <scroll-bar>
      <el-menu
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.name"
        :collapse="isCollapse"
        background-color="#303977"
        text-color="#8b94b7"
        active-text-color="#24d2ab"
      >
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
      <div style="height: 160px"></div>
    </scroll-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';
import ScrollBar from '@/components/ScrollBar';

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters(['sidebar', 'routers', 'routerName']),
    routes() {
      // return this.$router.options.routes
      let item = this.routers.filter(item => !item.hidden);
      return item;
    },

    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue